var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:'iframe' + _vm.threadMessage['@id'],attrs:{"sandbox":"allow-same-origin","width":"100%","height":"100%","frameborder":"0","scrolling":"no"}})
}
var staticRenderFns = []

export { render, staticRenderFns }